import { useEffect, useState } from "react";
import api from "../../shared/utils/request";
import PageLoader from "../shared/pageLoader";
import toast from "react-hot-toast";
import LoginWarning, { EmptyWishlist } from "../shared/warningPages";
import { usePageSeo } from "../../shared/seo";
import ProductView from "../shared/productView";

const WishlistPage = () => {
  usePageSeo("wishlist");

  const [wishlistDatas, setWishlistDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const isToken = localStorage.getItem("token");

  useEffect(() => {
    const getWishlistDatas = async () => {
      setLoading(true);
      try {
        const data = await api.post("customer/getWishList");
        setWishlistDatas(data?.wishlistItems || data?.data || []);
      } catch (error) {
        console.error("Failed to fetch wishlist data:", error);
      } finally {
        setLoading(false);
      }
    };

    getWishlistDatas();
  }, []);

  if (!isToken && !loading) {
    return <LoginWarning />;
  }

  if (!loading && wishlistDatas?.length === 0) {
    return <EmptyWishlist />;
  }

  return (
    <>
      {loading && <PageLoader />}
      <section className="py-80 overflow-hidden">
        <div className="container container-lg">
          <div className="mb-32">
            <h3 className="fw-bold text-main-700 mb-8">My Wishlist</h3>
            <p className="text-neutral-600 text-sm mb-0">
              {wishlistDatas.length} item{wishlistDatas.length !== 1 ? "s" : ""}{" "}
              saved
            </p>
          </div>

          <div className="row g-12">
            {wishlistDatas.map((item, index) => (
              <div className="col-6 col-md-2">
                <ProductView
                  key={item?.variant_id || item?.id || index}
                  product={{
                    id: item?.product_id,
                    variant_id: item?.variant_id,
                    slug: item?.product?.slug,
                    image: item?.variant?.product_image,
                    name: item?.variant?.title,
                    price: item?.variant?.sale_price,
                    originalPrice: item?.variant?.price,
                    quantityType: item?.variant?.quantity,
                    sold: item?.variant?.stock,
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default WishlistPage;
